import { ReactElement } from 'react';
import { UserModel } from '../models';
import { checkRBACAccess, is } from '../utils';
import { createRouteItems } from './factories/create-routes-items';
import { RouteItem } from './routes.types';

export interface SideBarRouteItem extends Omit<RouteItem, 'icon'> {
  icon: ReactElement;
  title: string;
}

class RoutesSingletonService {
  private availableRoutes: SideBarRouteItem[] | null = null;

  public getAvailableRoutes(
    user: UserModel,
    renew?: boolean,
  ): SideBarRouteItem[] {
    if (renew || this.availableRoutes === null) {
      this.availableRoutes = createRouteItems(user)
        .filter((route) => route.title && route.icon)
        .filter((routeItem: RouteItem) => {
          const { resourceType, roleAccessTypes, isHidden } = routeItem;

          return (
            (!resourceType ||
              checkRBACAccess(user, resourceType, roleAccessTypes)) &&
            (isHidden === undefined ||
              (is.boolean(isHidden) ? !isHidden : !isHidden(routeItem, user)))
          );
        })
        .map(({ icon: IconComponent, title, ...props }) => ({
          ...props,
          title,
          icon: <IconComponent size="20" />,
        }));
    }

    return this.availableRoutes;
  }
}

const routesSingletonService = new RoutesSingletonService();

export default routesSingletonService;
